module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Leicester.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Leicester.png
// module id = 2084
// module chunks = 4